import {Box, Grid2, Skeleton} from '@mui/material';

import {theme} from '@/config/theme';

const PackagesItemSkeleton = () => (
  <Grid2
    sx={{
      backgroundColor: theme.palette.background.paper,
      borderRadius: '8px',
      position: 'relative',
    }}
    size={4}
    spacing={3}
    padding="8px">
    <Box display={'flex'} flexDirection={'column'} alignItems={'start'}>
      <Grid2 container alignItems={'flex-end'} size={12}>
        <Grid2
          sx={{
            height: '85px',
            width: '100%',
            borderRadius: '12px',
            overflow: 'hidden',
          }}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height="100%"
            sx={{borderRadius: '12px'}}
          />
        </Grid2>
      </Grid2>

      <Skeleton
        variant="text"
        width="60%"
        height={12}
        sx={{mt: '10px', borderRadius: '4px'}}
      />
      <Skeleton
        variant="text"
        width="40%"
        height={10}
        sx={{mt: '4px', borderRadius: '4px'}}
      />
    </Box>

    <Grid2 size={12} mt={'12px'} display={'flex'} justifyContent={'center'}>
      <Skeleton
        variant="rectangular"
        width={66}
        height={18}
        sx={{
          borderRadius: '4px',
        }}
      />
    </Grid2>
  </Grid2>
);

export default PackagesItemSkeleton;
